export default __webpack_public_path__ + "static/media/pesa logo.e444f2c5.jpg";